import request from '@/utils/requestnew'
import baseUrl from './baseUrl'
import commonJs from '@/utils/common'

const BASE_URL = baseUrl + '/member'

export default {
    //列表接口
    getPageList(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getPageList',
            method: 'get',
            params,

        })
    },

    //添加
    add(data) {
        return request({
            url: BASE_URL + '/add',
            method: 'post',
            data
        })
    },

    //添加积分
    addPoints(data) {
        return request({
            url: BASE_URL + '/addPoints',
            method: 'post',
            data
        })
    },

    //编辑
    updateMember(data) {
        return request({
            url: BASE_URL + '/updateMember',
            method: 'post',
            data
        })
    },

    //会员积分历史记录
    pointsLog(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getPointsList',
            method: 'get',
            params,

        })
    },
    //添加积分兑换
    addRedeem(data) {
        return request({
            url: BASE_URL + '/addRedeem',
            method: 'post',
            data
        })
    },
    //积分兑换历史记录
    redeemLog(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getRedeemList',
            method: 'get',
            params,

        })
    },
    //会员积分历史记录(分页)
    pointsLogPage(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getPointsListPage',
            method: 'get',
            params,
        })
    },
    //积分兑换历史记录(分页)
    redeemLogPage(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getRedeemListPage',
            method: 'get',
            params,
        })
    },
    //导出列表excel
    listExcel() {
        return request({
            url: BASE_URL + '/exportListExcel',
            method: 'get',
            responseType: 'blob'
        })
    },
    //积分历史记录excel
    logExcel(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/logExcel',
            method: 'get',
            params,
            responseType: 'blob'
        })
    },
    //积分兑换记录excel
    redLogExcel(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/redLogExcel',
            method: 'get',
            params,
            responseType: 'blob'
        })
    },
    //未使用的红包列表
    getRedPacket(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getRedPacket',
            method: 'get',
            params
        })
    },
    //红包使用记录(分页)
    getCouponsLog(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getCouponsLog',
            method: 'get',
            params,
        })
    },
    //优惠券使用记录(分页)
    getCashLog(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getCashLog',
            method: 'get',
            params,
        })
    },
    //抽奖(分页)
    getLuckLog(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getLuckLog',
            method: 'get',
            params,
        })
    },
    //ERP订单
    getErpListPage(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getErpListPage',
            method: 'get',
            params,
        })
    },
    //判断身份
    getShowExcel() {
        return request({
            url: BASE_URL + '/getShowExcel',
            method: 'get',
        })
    },
    //录错，退货
    addFalsePoints(data) {
        return request({
            url: BASE_URL + '/addFalsePoints',
            method: 'post',
            data
        })
    },
    //导出红包注册excel
    listAllExcel() {
        return request({
            url: BASE_URL + '/exportAllListExcel',
            method: 'get',
            responseType: 'blob'
        })
    },
    //导出红包使用excel
    listUseExcel() {
        return request({
            url: BASE_URL + '/exportUseListExcel',
            method: 'get',
            responseType: 'blob'
        })
    },
    //导出所有会员信息以及积分
    exportAllList() {
        return request({
            url: BASE_URL + '/exportAllList',
            method: 'get',
            responseType: 'blob'
        })
    },
}